export const MaxUint256 = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';

export const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;

window.config = { STRAPI_URL };
